import { useEffect, useRef } from 'react';

type Props = {
  currentState?: boolean;
  onSuccess?: () => void;
  error?: any;
  onError?: () => void;
  enabled?: boolean;
};

export const useWasEnabled = ({
  currentState,
  onSuccess,
  onError,
  error,
  enabled,
}: Props) => {
  const wasSuccessHandled = useRef(false);
  const wasErrorHandled = useRef(false);

  useEffect(() => {
    if (!enabled) {
      wasSuccessHandled.current = false;
      wasErrorHandled.current = false;
    }
  }, [enabled]);

  useEffect(() => {
    if (enabled && currentState && !wasSuccessHandled.current) {
      onSuccess?.();
      wasSuccessHandled.current = true;
    }
  }, [currentState, enabled, onSuccess]);

  useEffect(() => {
    if (
      enabled &&
      !wasErrorHandled.current &&
      !!error &&
      !wasSuccessHandled.current
    ) {
      onError?.();
      wasErrorHandled.current = true;
    }
  }, [enabled, error, onError]);
};
